import React from 'react';
import ReactDOM from 'react-dom';
import charWatchTrack from '../shared/CharWatchTrack';

class UcWatch extends React.Component {
    render() {
        return (
            <div></div>
        );
    }
}

export default charWatchTrack(UcWatch, 'uc', 'watch');


// WEBPACK FOOTER //
// ./src/components/sections/uc/UcWatch.js